import { takeLeading, put, all, call } from "redux-saga/effects";
import AuthActionTypes from "./auth.types";
import { userSigninFailure, userSigninSuccess } from "./auth.actions";
// import AppConfig from "../../config/app.config";
import UserService from "../../services/user/user.service";
// import MqttService from "../../services/mqtt/mqtt.service";

/** performs user signin */
export function* userSignin({ payload }) {
    try {
        const signInData = {
            username: payload.username,
            password: payload.password,
            appId: payload.appId,
        };
        const res = yield UserService.signIn(signInData);
        // console.log(res);
        if (res.error != null) {
            yield put(
                userSigninFailure({
                    signinSuccess: false,
                    loading: false,
                    err: res.error.response.data.message,
                })
            );
        } else {
            if (res["status"]) {
                const data = res["data"][0];
                yield put(
                    userSigninSuccess({
                        signinSuccess: true,
                        loading: true,
                        employee: data.employees[0],
                        subscritions: null,
                    })
                );
            } else {
                yield put(
                    userSigninFailure({
                        signinSuccess: false,
                        loading: false,
                        err: res["message"],
                    })
                );
            }
        }
    } catch (err) {
        yield put(userSigninFailure({ signinSuccess: false, loading: false, err: err }));
    }
}

export function* userSigninWithSubscription({ payload }) {
    try {
        const signInData = {
            username: payload.username,
            password: payload.password,
            appId: payload.appId,
        };
        const res = yield UserService.signInWithSubscription(signInData);
        // console.log(res);
        if (res.error != null) {
            yield put(
                userSigninFailure({
                    signinSuccess: false,
                    loading: false,
                    err: res.error.response.data.message,
                })
            );
        } else {
            if (res["status"]) {
                const data = res["data"].subscriptions;
                yield put(
                    userSigninSuccess({
                        signinSuccess: true,
                        loading: true,
                        employee: null,
                        subscriptions: data,
                    })
                );
            } else {
                yield put(
                    userSigninFailure({
                        signinSuccess: false,
                        loading: false,
                        err: res["message"],
                    })
                );
            }
        }
    } catch (err) {
        yield put(userSigninFailure({ signinSuccess: false, loading: false, err: err }));
    }
}

/** Saga for user signin */
export function* userSigninSaga() {
    yield takeLeading(AuthActionTypes.SIGNIN_START, userSigninWithSubscription);
}

/**
 * Initialise all local sagas
 */
export function* authSagas() {
    yield all([call(userSigninSaga)]);
}
